export default {
  methods: {
    getReadabledFloat: function(float) {
      return parseFloat(float);
    }
  }
}